module.exports = __webpack_public_path__ + "static/img/completed_task_.23a70b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antarmuka-user/img/completed_task_.png
// module id = q2ua
// module chunks = 1